import React, { Component } from "react";
import PilaForm from "../PilaForm/PilaForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AccountingPage
Description : Componente que contienen el formulario de la pantalla Accounting 
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente AccountingForm
================================================================================ */
class PilaPage extends Component{
    render(){
        return(
            <div>                    
                <PilaForm/>
            </div>
        )   
    }
}

export default PilaPage;